<template>
<div class="orders-page">

  <!-- Header -->
  <!-- <div class="orders-header">
    <div class="orders-header__inner">
      <div class="orders-title">
        <div class="orders-title__h">Siparişler</div>
        <div class="orders-title__sub">
          {{ obje.t1 }} # {{ obje.t2 }} tarihleri arasında
          <b>{{ posts.length }}</b> adet sipariş listeleniyor
        </div>
      </div>
    </div>
  </div> -->

  <!-- Content -->
  <div class="orders-layout" style="padding-top:20px">

    <!-- Left: List -->
    <div class="orders-main">
      <div class="panel">
        <!-- Desktop table -->
        <div class="table-wrap">
          <table class="orders-table">
            <thead>
              <tr>
                <th>Ekleyen</th>
                <th>Müşteri</th>
                <th>EvrakNo</th>
                <th>Tarih</th>
                <th>Nerden</th>
                <th>Teslim Türü</th>
                <th>Ödeme</th>
                <th class="th-center">Detay</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in posts" :key="item.sira || index">
                <td>{{ $helper.ilkharfBuyuk(item.ad) }}</td>
                <td class="td-strong">{{ $helper.ilkharfBuyuk(item.baslik) }}</td>
                <td>{{ item.seri + ' - ' + item.sira }}</td>
                <td>{{ $helper.trtgosternoktali(item.tarih) }}</td>
                <td>{{ item.seri }}</td>
                <td>{{ $helper.ilkharfBuyuk(item.teslim) }}</td>
                <td>{{ paymentText(item) }}</td>
                <td class="td-center">
                  <router-link class="icon-btn" :to="'/siparis/' + item.sira" aria-label="Detay">
                    <i class="icon-menu"></i>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Mobile cards -->
        <div class="orders-cards">
          <div
            v-for="(item, index) in posts"
            :key="'m-' + (item.sira || index)"
            class="order-card"
          >
            <div class="order-card__top">
              <div class="order-card__title">
                {{ $helper.ilkharfBuyuk(item.baslik) }}
              </div>
              <router-link class="icon-btn" :to="'/siparis/' + item.sira" aria-label="Detay">
                <i class="icon-menu"></i>
              </router-link>
            </div>

            <div class="order-card__meta">
              <div><span class="k">Ekleyen</span><span class="v">{{ $helper.ilkharfBuyuk(item.ad) }}</span></div>
              <div><span class="k">Evrak</span><span class="v">{{ item.seri }} - {{ item.sira }}</span></div>
              <div><span class="k">Tarih</span><span class="v">{{ $helper.trtgosternoktali(item.tarih) }}</span></div>
              <div><span class="k">Teslim</span><span class="v">{{ $helper.ilkharfBuyuk(item.teslim) }}</span></div>
              <div><span class="k">Ödeme</span><span class="v">{{ paymentText(item) }}</span></div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Right: Filters -->
    <aside class="orders-side">
      <div class="panel">
        <div class="panel-title">Sipariş Ara</div>

        <div class="form-grid">
          <label class="field">
            <span class="field__label">Başlangıç</span>
            <input class="field__input" type="date" v-model="obje.t1">
          </label>

          <label class="field">
            <span class="field__label">Bitiş</span>
            <input class="field__input" type="date" v-model="obje.t2">
          </label>

          <button class="btn-primary" type="button" @click="getir()">
            Filtrele
          </button>
        </div>
      </div>
    </aside>

  </div>
</div>

</template>

<script>
//import { req } from "@/plugins/axios";
import { router } from '@/router';

export default {

  data() {
    return {
      hesap:this.$request.ayar(),


      obje : {
        root: this.$request.ayar().root,
        kid: this.$request.ayar().kid,
        entegrekodu: this.$request.ayar().entegrekodu, // personel mi müşterimi hesaplama için
        ckod: this.$store.aktifCari.kod,
        tip: 1,
        onaylimi: 1,
        t1: new Date().getFullYear() + ".01.01",
        t2: this.$helper.trtgosternoktali(new Date() + 1),
      },
      posts: [],
    };
  },
  created() {
    this.$store.setLoading([false,''])
    this.getir();
  },
  methods: {
    paymentText(item) {
      const raw = (item && item.odeme != null) ? String(item.odeme) : "";
      const v = raw.trim();
      if (!v || v === "0") return "Cari Hesap";
      if (v.toLowerCase() === "açık hesap" || v.toLowerCase() === "acik hesap") return "Açık Hesap";
      return "Kredi Kartı - " + v;
    },

    getir() {
        this.$store.setLoading([true,'Bekleyiniz'])
      this.$request
        .post("crm/bildirim/liste", this.obje)
        .then((res) => {
          console.log(res)

          if (res.status) {
            this.$store.setLoading([false,''])
            this.posts = res.data;
        }
          else{
            this.$router.push("/oturum")
          }
        });
    },


  },
};
</script>
<style scoped>
/* Page */
.orders-page{
  background:#f2f2f2;
  min-height:100%;
  margin: 0 auto;
}

/* Header */
.orders-header{
  position: sticky;
  top: 0;
  z-index: 20;
  background: #fff; /* modern kırmızı */
  color: #484848;
  border-bottom: 1px solid rgba(255,255,255,.15);
}
.orders-header__inner{
  max-width: 1200px;
  margin: 0 auto;
  padding: 14px 14px;
}
.orders-title__h{
  font-size: 20px;
  font-weight: 800;
  letter-spacing: .2px;
}
.orders-title__sub{
  margin-top: 4px;
  font-size: 13px;
  opacity: .92;
}

/* Layout */
.orders-layout{
  max-width:100%;
  margin: 14px auto;
  padding: 0 14px 14px;
  display: grid;
  grid-template-columns: 1fr 320px;
  gap: 12px;
}

.panel{
  background:#fff;
  border:1px solid #e9ecf3;
  border-radius: 14px;
  box-shadow: 0 10px 22px rgba(17,24,39,0.06);
  overflow:hidden;
}

/* Table */
.table-wrap{
  overflow-x: auto;
}
.orders-table{
  width:100%;
  border-collapse: separate;
  border-spacing: 0;
}
.orders-table thead th{
  text-align:left;
  font-size: 12px;
  color:#6b7280;
  padding: 12px 14px;
  background:#fafafa;
  border-bottom:1px solid #eef1f6;
  white-space: nowrap;
}
.orders-table tbody td{
  padding: 12px 14px;
  border-bottom:1px solid #f0f2f6;
  font-size: 13px;
  color:#111827;
  vertical-align: middle;
  white-space: nowrap;
}
.orders-table tbody tr:hover{
  background:#fbfbfd;
}
.td-strong{
  font-weight: 700;
}
.th-center, .td-center{
  text-align:center;
}

/* Icon button */
.icon-btn{
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display:inline-flex;
  align-items:center;
  justify-content:center;
  border:1px solid #e5e7eb;
  background:#fff;
  color:#111827;
  text-decoration:none;
}
.icon-btn:hover{
  background:#f3f4f6;
}

/* Side */
.orders-side .panel{
  padding: 14px;
}
.panel-title{
  font-size: 15px;
  font-weight: 800;
  color:#111827;
  margin-bottom: 10px;
}
.form-grid{
  display:grid;
  gap: 10px;
}
.field__label{
  display:block;
  font-size: 12px;
  color:#6b7280;
  margin-bottom: 6px;
}
.field__input{
  width:100%;
  height: 46px;
  border-radius: 12px;
  border:1px solid #e5e7eb;
  background:#f9fafb;
  padding: 0 12px;
  font-size: 15px;
  outline: none;
}
.field__input:focus{
  border-color:#b91c1c;
  box-shadow: 0 0 0 4px rgba(185,28,28,.12);
  background:#fff;
}
.btn-primary{
  height: 46px;
  border:0;
  border-radius: 12px;
  background:#b91c1c;
  color:#fff;
  font-size: 16px;
  font-weight: 800;
  cursor:pointer;
}
.btn-primary:hover{
  filter: brightness(0.95);
}

/* Mobile: switch to cards */
.orders-cards{ display:none; padding: 12px; }

.order-card{
  border:1px solid #eef1f6;
  border-radius: 14px;
  padding: 12px;
  background:#fff;
  margin-bottom: 10px;
}
.order-card__top{
  display:flex;
  align-items:flex-start;
  justify-content:space-between;
  gap: 10px;
  margin-bottom: 8px;
}
.order-card__title{
  font-size: 14px;
  font-weight: 800;
  color:#111827;
}
.order-card__meta{
  display:grid;
  gap: 6px;
  font-size: 13px;
}
.order-card__meta .k{
  display:inline-block;
  min-width: 70px;
  color:#6b7280;
}
.order-card__meta .v{
  color:#111827;
  font-weight: 600;
}

/* Responsive */
@media (max-width: 980px){
  .orders-layout{
    grid-template-columns: 1fr;
  }
  .orders-side{
    order: -1; /* filtreyi üste al (isteğe bağlı) */
  }
}
@media (max-width: 720px){
  .table-wrap{ display:none; }
  .orders-cards{ display:block; }
}

</style>



// WEBPACK FOOTER //
// src/views/siparis/list.vue